import { render, staticRenderFns } from "./ProfileWithdrawalLimit.vue?vue&type=template&id=3e2be1a4&"
import script from "./ProfileWithdrawalLimit.vue?vue&type=script&lang=js&"
export * from "./ProfileWithdrawalLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports